var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 13C2.375 7.13198 7.13198 2.375 13 2.375C18.868 2.375 23.625 7.13198 23.625 13V15.5H20.8125C20.2947 15.5 19.875 15.9197 19.875 16.4375V24.5625C19.875 25.0803 20.2947 25.5 20.8125 25.5H21.75C23.8211 25.5 25.5 23.8211 25.5 21.75V13C25.5 6.09644 19.9035 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13V21.75C0.5 23.8211 2.17894 25.5 4.25 25.5H5.1875C5.70526 25.5 6.125 25.0803 6.125 24.5625V16.4375C6.125 15.9197 5.70526 15.5 5.1875 15.5H2.375V13ZM23.625 17.375V21.75C23.625 22.7855 22.7855 23.625 21.75 23.625V17.375H23.625ZM2.375 21.75V17.375H4.25V23.625C3.21446 23.625 2.375 22.7855 2.375 21.75ZM13.9375 12.6875C13.9375 12.1697 13.5178 11.75 13 11.75C12.4822 11.75 12.0625 12.1697 12.0625 12.6875V25.8125C12.0625 26.3303 12.4822 26.75 13 26.75C13.5178 26.75 13.9375 26.3303 13.9375 25.8125V12.6875ZM8.9375 15.4997C9.45526 15.4997 9.875 15.9194 9.875 16.4372V22.0625C9.875 22.5803 9.45526 23 8.9375 23C8.41974 23 8 22.5803 8 22.0625V16.4372C8 15.9194 8.41974 15.4997 8.9375 15.4997ZM18 16.4375C18 15.9197 17.5803 15.5 17.0625 15.5C16.5447 15.5 16.125 15.9197 16.125 16.4375V22.0628C16.125 22.5805 16.5447 23.0003 17.0625 23.0003C17.5803 23.0003 18 22.5805 18 22.0628V16.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.3f5cf9316bb8c4facb0793c04acafffd.svg";
export { ForwardRef as ReactComponent };